
import { Component, Vue } from 'vue-property-decorator'
import store, { IState, Mutations } from './store'
import { Mutation, State } from 'vuex-class'
import compatibility from './services/compatibility.service'

@Component
export default class AppController extends Vue {
  @State((state: IState) => state.messages.getUserMedia)
  private messagesGetUserMedia!: boolean

  @Mutation(Mutations.UPDATE_MESSAGES)
  private updateMessages!: (value: { messages: IState['messages'] }) => void

  public get showGetUserMediaMessage() {
    return !compatibility.getUserMedia && !this.messagesGetUserMedia
  }

}
